var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49991 8.5V1.5H5.49991V6.49998H4.50003V5.49998H3.50003V6.49998H4.49997V7.49998H5.49991V8.5H6.49991ZM10.4999 9.49997V7.49998H9.49991V9.49997L2.49991 9.49997L2.49991 7.49998H1.49991L1.49991 9.49997V10.5V10.5H2.49991V10.5L9.49991 10.5V10.5H10.4999V10.5V9.49997ZM6.5 6.49997V7.49997H7.5V6.49997H8.5V5.49997H7.5V6.49997H6.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadS);
export default __webpack_public_path__ + "static/media/download-s.4e267c2e530da96445ae32943a1f9d35.svg";
export { ForwardRef as ReactComponent };